import React from 'react';
import { useNavigate } from 'react-router-dom';

const LearnMore = () => {
  let navigate = useNavigate()
  const HandleReview = ()=>{ 
    navigate("/order")
   }
  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4">
      {/* Page Header */}
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold text-gray-800">Learn More</h1>
        <p className="text-gray-600 mt-2">Everything you need to know about our shipping process.</p>
      </div>

      {/* Shipping Information Section */}
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Products Shipped from Jumia
        </h2>
        <p className="text-gray-600 leading-relaxed">
          We are proud to partner with <span className="font-bold text-blue-500">Jumia</span> to provide you with high-quality products at competitive prices. 
          All our products are carefully sourced and shipped directly from Jumia to ensure quick and reliable delivery. By leveraging Jumia's trusted logistics 
          network, we guarantee that your orders will arrive on time and in excellent condition.
        </p>

        <p className="text-gray-600 leading-relaxed mt-4">
          With Jumia's efficient shipping solutions, you can enjoy:
        </p>
        <ul className="list-disc pl-6 text-gray-600 mt-2 space-y-2">
          <li>Fast delivery to your doorstep.</li>
          <li>Secure packaging to protect your items.</li>
          <li>Tracking options for your convenience.</li>
          <li>Access to exclusive deals and promotions.</li>
        </ul>
        
        <p className="text-gray-600 mt-4">
          If you have any questions about your shipment or would like to know more about our products, please feel free to contact us. We’re here to help!
        </p>
      </div>

      {/* Call-to-Action Button */}
      <div className="text-center mt-10">
        <button
          className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition"
          onClick={HandleReview}
        >
          Go Back to Products
        </button>
      </div>
    </div>
  );
};

export default LearnMore;
